import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map, Observable } from 'rxjs';
import { IApiCampaign } from '../api-model/campaign.api';
import { Campaign, CampaignAdapter } from '../model/campaign';

@Injectable({ providedIn: 'root' })
export class CampaignNextApi {
  private adapter = new CampaignAdapter();

  constructor(private http: HttpClient) {}

  list(): Observable<Campaign[]> {
    const url = '/api/next/campaigns/';

    return this.http.get(url).pipe(
      // We're probably not going to need pagination for campaigns, so we're
      // just mapping it to a list of campaigns, when provided with a paginated
      // result.
      map((data: Record<string, any>) =>
        ((data['results'] || data) as IApiCampaign[]).map((item) =>
          this.adapter.adapt(item),
        ),
      ),
    );
  }

  get(id: string): Observable<Campaign> {
    const url = `/api/next/campaigns/${id}/`;

    return this.http
      .get<IApiCampaign>(url)
      .pipe(map((item) => this.adapter.adapt(item)));
  }
}
